module.exports = __webpack_public_path__ + "static/media/_heart.ba1ff5aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_heart.jpg
// module id = 44
// module chunks = 0